import React, {useState, useMemo} from 'react';
import * as Yup from 'yup';
import {
  Button,
  Box,
  Card,
  Typography,
  MenuItem,
  TextField
} from '@mui/material';
import Iconify from 'src/components/iconify';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import FormProvider, {RHFEditor} from 'src/minimal-components/hook-form';
import parse from 'html-react-parser';
import {Container} from '@mui/system';
import CustomPopover, {usePopover} from '@components/custom-popover';
import QuestionDialogFeedback from './QuestionDialogFeedback';
import DragDropContentDisplay from '../Assessment/Addquestion/dragdrop';
interface FeedbackFormCreationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formquestionsData: any[];
  feedbackname: string;
  introductiondata: any;
  thanksdata: any;
  id: number;
}
interface FeedbackOpenProps {
  onSaveClose: (formData: any) => void;
  feedbacksavedQuestions: FeedbackFormCreationProps;
  questionfeedbackid: number;
  // eslint-disable-next-line react/boolean-prop-naming
  editmodefeedback?: boolean;
}
const overviewData = `
<h4>Share your feedback and tell us about your experience with this course.
</h4>
`;
const thankyouData = `

<h3>Thank you for your feedback!
</h3>
`;
const feedbackname = 'Feedback';
const questionObject = [
  {
    disableComments: true,
    makecommentmandatory: true,
    markasMandatory: true,
    choices: [
      {id: 1, value: '1'},
      {id: 2, value: '2'}
    ],
    id: 1,
    question: 'data',
    questionType: 'single'
  }
];
const FeedbackOpen: React.FC<FeedbackOpenProps> = ({
  onSaveClose,
  feedbacksavedQuestions,
  questionfeedbackid,
  editmodefeedback
}) => {
  const [questionIdsupda, setQuestionidsupda] =
    useState<number>(questionfeedbackid);
  const [opening, setOpening] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editQuestions, setEditQuestions] = useState<any>();
  const [intromode, setIntromode] = useState(false);
  const [thanksdata, setThanksdata] = useState<string>(thankyouData);
  const [introductiondata, setIntroductiondata] =
    useState<string>(overviewData);
  const [questions, setQuestionsdata] = useState<any[]>([]);
  const [questionids, setQuestionids] = useState<number>(0);
  const [feedbacknamesetting, setFeedbacknamesetting] =
    useState<string>(feedbackname);
  const popover = usePopover();
  const NewJobSchema = Yup.object().shape({
    feedbackname: Yup.string().required('Feedback name required'),
    content: Yup.string().required('Content is required'),
    thankyou: Yup.string().required('Thank you ')
  });
  React.useEffect(() => {
    setQuestionsdata(questionObject);
  }, []);
  const defaultValues = useMemo(
    () => ({
      feedbackname: feedbacknamesetting || feedbackname,
      content: introductiondata || overviewData,
      thankyou: thanksdata || thankyouData
    }),
    []
  );

  React.useEffect(() => {
    setQuestionsdata(questionObject);
  }, []);
  React.useEffect(() => {
    if (editmodefeedback && feedbacksavedQuestions) {
      setQuestionidsupda(feedbacksavedQuestions.id);
      setFeedbacknamesetting(feedbacksavedQuestions.feedbackname);
      setIntroductiondata(feedbacksavedQuestions.introductiondata);
      setThanksdata(feedbacksavedQuestions.thanksdata);
      setQuestionsdata(feedbacksavedQuestions.formquestionsData);
      const maxId = feedbacksavedQuestions.formquestionsData.reduce((max, obj) => obj.id > max ? obj.id : max, feedbacksavedQuestions.formquestionsData[0].id);
      setQuestionids(maxId+1)
    }
  }, [feedbacksavedQuestions]);

  const methods = useForm({
    resolver: yupResolver(NewJobSchema),
    defaultValues
  });

  const {handleSubmit} = methods;
  const handleClicks = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpening(true);
    setEditQuestions('value');
  };

  const handleClose = () => {
    popover.onClose();
  };

  const handleDivClick = () => setEditMode(true);
  const handleCancel = () => {
    setThanksdata(thankyouData);
    setEditMode(false);
  };
  const handleDivClicks = () => setIntromode(true);
  const handleCancels = () => {
    setIntroductiondata(overviewData);
    setIntromode(false);
  };
  const handleSave = handleSubmit((data: any) => {
    setThanksdata(data.thankyou);
    setEditMode(false);
    setIntroductiondata(data.content);
    setIntromode(false);
  });
  const handleCloseAddquestion = () => {
    setEditQuestions(null);
    setOpening(false);
  };
  const handleDeleteQuestion = (id: string) => {
    setQuestionsdata(prevQuestions =>
      prevQuestions.filter(question => question.id !== id)
    );
  };
  const handleEditQuestion = (id: any) => {
    setEditQuestions(id);
    setOpening(true);
  };
  const handlenamechange = (e: any) => {
    setFeedbacknamesetting(e.target.value);
  };
  // Function to handle data received from the QuestionForm
  const handleSaveData = (formData: any) => {
    {
      formData && formData.id && setQuestionids(formData.id + 1);
    }
    if (editQuestions && editQuestions.id) {
      const updatedQuestions = questions.map(question =>
        question.id === editQuestions.id ? formData : question
      );
      setQuestionsdata(updatedQuestions);
      setEditQuestions(null);
    } else {
      setQuestionsdata([...questions, formData]);
      setEditQuestions(null);
    }
    setOpening(false);
    handleClose();
  };

  return (
    <Container sx={{width: '100%', p: 3}}>
      <Card variant="outlined" sx={{padding: '1vh 1.5vh', marginBottom: '2vh'}}>
        <FormProvider methods={methods}>
          <TextField
            fullWidth
            name="feedbackname"
            value={feedbacknamesetting || feedbackname}
            label="feedback Title"
            onChange={(e: any) => handlenamechange(e)}
          />
        </FormProvider>
      </Card>
      <Card variant="outlined" sx={{padding: '1vh 1.5vh', marginBottom: '2vh'}}>
        <Typography variant="h1" sx={{mt: 2, mb: 1}}>
          Introduction
        </Typography>
        {intromode ? (
          <FormProvider methods={methods} styles={{marginTop: '-4vh'}}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
              <Button
                type="reset"
                variant="outlined"
                sx={{mb: '3px', mr: 2}}
                onClick={handleCancels}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{mb: '3px'}}
                onClick={handleSave}>
                Save
              </Button>
            </div>
            <RHFEditor
              simple
              name="content"
              sx={{
                width: '-webkit-fill-available',
                maxHeight: '25vh',
                overflowY: 'auto'
              }}
            />
          </FormProvider>
        ) : (
          <div style={{borderRadius: '8px'}}>
            <div style={{margin: '1vh 1vh'}} onClick={handleDivClicks}>
              {parse(introductiondata)}
            </div>
          </div>
        )}
      </Card>
      <Card variant="outlined" sx={{padding: '1vh 1.5vh', marginBottom: '2vh'}}>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between'
          }}>
          <Typography variant="h1" sx={{mt: 2, mb: 1}}>
            Feedback Questions
          </Typography>

          <div
            style={{
              backgroundColor: '#212B36',
              borderRadius: '0px',
              marginBottom: '8px'
            }}>
            <Button
              id="add-question-button"
              variant="contained"
              onClick={handleClicks}
              sx={{p: '4px', borderRadius: '0px'}}>
              Add Question
            </Button>
            <Button
              variant="contained"
              onClick={popover.onOpen}
              endIcon={
                <Iconify
                  sx={{display: 'block', m: 0}}
                  icon={
                    popover.open
                      ? 'eva:arrow-ios-upward-fill'
                      : 'eva:arrow-ios-downward-fill'
                  }
                />
              }
              sx={{p: '4px 8px', borderRadius: '0px', minWidth: '40px'}}
            />
          </div>
          <CustomPopover
            open={popover.open}
            onClose={popover.onClose}
            arrow="top-right"
            sx={{width: 160}}>
            <MenuItem onClick={handleClose}>
              Select from existing questions
            </MenuItem>
          </CustomPopover>
        </div>
        <Box
          sx={{
            my: 2,
            border: 'groove',
            borderRadius: '8px',
            p: '0.8vh'
          }}>
          <DragDropContentDisplay
            handleDeleteQuestion={handleDeleteQuestion}
            handleEditQuestion={handleEditQuestion}
            questiondata={questions}
          />
        </Box>
      </Card>

      <Card variant="outlined" sx={{padding: '1vh 1.5vh'}}>
        <Typography variant="h1" sx={{mt: 2, mb: 1}}>
          Thanking You
        </Typography>
        {editMode ? (
          <FormProvider methods={methods} styles={{marginTop: '-4vh'}}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center'
              }}>
              <Button
                type="reset"
                variant="outlined"
                sx={{mb: '3px', mr: 2}}
                onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{mb: '3px'}}
                onClick={handleSave}>
                Save
              </Button>
            </div>
            <RHFEditor
              simple
              name="thankyou"
              sx={{
                width: '-webkit-fill-available',
                maxHeight: '16vh',
                overflowY: 'auto'
              }}
            />
          </FormProvider>
        ) : (
          <div style={{border: 'groove', borderRadius: '8px'}}>
            <div
              style={{margin: '1vh 3vh', minHeight: '14vh', maxHeight: '14vh'}}
              onClick={handleDivClick}>
              {parse(thanksdata)}
            </div>
          </div>
        )}
      </Card>
      <div>
        {editmodefeedback ? (
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onSaveClose({
                formquestionsData: questions,
                feedbackname: feedbacknamesetting,
                introductiondata: introductiondata,
                thanksdata: thanksdata,
                id: questionIdsupda
              });
            }}
            sx={{marginTop: '1vh'}}>
            Save
          </Button>
        ) : (
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onSaveClose({
                formquestionsData: questions,
                feedbackname: feedbacknamesetting,
                introductiondata: introductiondata,
                thanksdata: thanksdata,
                id: questionIdsupda
              });
            }}
            sx={{marginTop: '1vh'}}>
            Save
          </Button>
        )}
      </div>
      <QuestionDialogFeedback
        questionIds={questionids}
        open={opening}
        handleEditQuestion={editQuestions}
        onClose={handleCloseAddquestion}
        onSave={handleSaveData}
      />
    </Container>
  );
};

export default FeedbackOpen;
